import { TodoKind } from 'generated/graphql';

type TargetType = 'Document' | undefined;
type TodoKindMeta = { title: String; description: String };
type TargetTypeMeta = Record<TodoKind, TodoKindMeta>;

const KIND_MAP: Record<NonNullable<TargetType>, Partial<TargetTypeMeta>> = {
  Document: {
    EXPIRATION: {
      title: 'Document expiration',
      description:
        'Your document is about to expire. You should either send a renewal request to the client or upload a new one manually.',
    },
    NO_EXPIRATION_DATE: {
      title: 'Set document expiration',
      description:
        "You have not set an expiration date for this document. You should set an expiration date in the document's setting page or mark the document as non-expiring.",
    },
  },
};

export const todoKindMeta = (targetType: TargetType, kind: TodoKind): TodoKindMeta =>
  (targetType && KIND_MAP[targetType][kind]) || { title: 'Unknown', description: 'Unknown' };
